export default "__VITE_ASSET__CKf_k0Cn__"